define('ordersDetailOrderStatusStatusesView',[
  'module',
  'app',
  'backbone',
  'underscore',
  'settings',
  'marionette',
  'orderUtils',
  'ordersMailsUtils',
  'ordersController',
  'ordersDetailOrderStatusStatusView',
  'entities/orders'
], function (
  Module,
  App,
  Backbone,
  _,
  Settings,
  Marionette,
  OrderUtils,
  OrdersMailsUtils,
  Controller,
  OrdersDetailOrderStatusStatusView
) {
  'use strict';

  Module.exports = Marionette.CollectionView.extend({
    tagName: 'select',
    className: 'orders-detail-order-status-status-view',
    childView: OrdersDetailOrderStatusStatusView,  
    
    ui: {
      'empty': '.empty'
    },

    events: {
      'change': 'onSelectChange'
    },

    modelEvents: {
      'change:commandType': 'setCollection',
      'change:status': 'setSelected'
    },

    initialize: function () {     
      this.collection = new Backbone.Collection();      
    },   

    onShow: function () {
      this.setCollection();
    },

    onRender: function () {
      this.setSelected();
    },

    setCollection: function () {
      OrderUtils.getAvailableStatuses(this.model.get('commandType')).done(_.bind(function (statuses) {
        this.collection.reset();
        this.collection.add(statuses);
        this.setSelected();
      }, this));      
    },

    setSelected: function () {
      _.each(this.children._views, _.bind(function (view) {
        if(view.model.get('statusConst') === this.model.get('status'))
          view.setSelected(true);
        else
          view.setSelected(false);
      }, this));
    },

    onSelectChange: function (e) {
      if(!this.model.get('poi'))
        return;

      this.model.updateStatus(e.target.value)
      .done(_.bind(function () {
        this.model.fetch();

        this.model.fetchListData().done(_.bind(function (data) {
          var listData = App.request('order:parse-list-data', data);       
          this.model.set('trackings', listData.trackings);

          try {
            App.request('orders:statuses', this.model.get('commandType')).done(_.bind(function (statuses) {
              var status = null;
              _.each(statuses.models, _.bind(function (item) {
                if(item.get('statusConst') === e.target.value)
                  status = item;
              }, this));

              if(status && status.get('params')) {
                var params = JSON.parse(status.get('params'));

                OrdersMailsUtils.check([this.model], params).done(_.bind(function () {
                var type = null;
                if(params && params.type)
                  type = params.type;

                if(type === 'sendMail') {
                  var template = null;
                  if(params.params && params.params.type)
                    template = params.params.type;

                  if(template) {
                    var configTemplate = null;
                    _.each(Settings.configValue('mails.templates'), function (s) {
                      if (s.template === template)
                        configTemplate = s;
                    }, this);

                    if (configTemplate)
                      OrdersMailsUtils.sendMail([this.model], configTemplate);
                  }
                }
              }, this));
              }
            }, this));
          } catch (e) {
            console.log(e);
          }
        }, this));
      }, this))
      .fail(_.bind(function () {
        this.render();
      }, this));
    }
  });
});
